module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Leistungen.8dac155e.png";